import React, { useRef, useState, useEffect } from 'react';
import '../../../styles/videoContainer.css';

const VideoContainer = ({src}) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    const handleTimeUpdate = () => {
      setCurrentTime(video.currentTime);
    };
    const handleLoadedMetadata = () => {
      setDuration(video.duration);
    };
    video.addEventListener('timeupdate', handleTimeUpdate);
    video.addEventListener('loadedmetadata', handleLoadedMetadata);
    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
      video.removeEventListener('loadedmetadata', handleLoadedMetadata);
    };
  }, []);

  const togglePlay = () => {
    const video = videoRef.current;
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const handleProgressChange = (e) => {
    const video = videoRef.current;
    const time = (e.target.value / 100) * video.duration;
    video.currentTime = time;
  };

  const toggleFullscreen = () => {
    const videoContainer = videoRef.current.parentElement;
    if (!document.fullscreenElement) {
      videoContainer.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  const togglePiP = async () => {
    const video = videoRef.current;
    try {
      if (document.pictureInPictureElement) {
        await document.exitPictureInPicture();
      } else {
        if (video.paused) await video.play();
        await video.requestPictureInPicture();
      }
    } catch (error) {
      console.error('PiP failed:', error);
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, '0');
    const seconds = Math.floor(time % 60)
      .toString()
      .padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  console.log(isPlaying,"fff")
  return (
    <main className='main-video'>
    <div className="video-container">
      <video
        ref={videoRef}
        src={src}
        loop
        muted
        playsInline
        className="video-element"
      />
      <div className="controls">
        <button onClick={togglePlay}>
          <img src={isPlaying ? '/images/pause.svg' : '/images/play.svg'} alt="play pause button" />
        </button>

        <input
          type="range"
          className="progress-bar"
          min="0"
          max="100"
          value={(currentTime / duration) * 100 || 0}
          onChange={handleProgressChange}
        />

        <span className="time">
          {formatTime(currentTime)} / {formatTime(duration)}
        </span>

        <button onClick={togglePiP}>
        <img src="/images/minize.svg" alt="pip" />
        </button>
        <button onClick={toggleFullscreen}>
        <img src={isFullscreen ? '/images/half-screen.svg' : '/images/expand.svg'} alt="full screen" />
          </button>
      </div>
    </div>
    </main>
  );
};

export default VideoContainer;
